import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../RaceStableList/RaceStableList.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import React from 'react';
import useResponsive from '../../hooks/useResponsive';
import TrainingTable from './TrainingTable';
const TrainingView = () => {
    const isResponsive = useResponsive('xl');
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [!isResponsive && _jsx(SubHeader, { background: true, title: 'Training program' }), _jsx("div", Object.assign({ className: 'd-flex w-100' }, { children: _jsx(TrainingTable, {}) }))] })));
};
export default TrainingView;
